export default __webpack_public_path__ + "static/media/鄭湘筠.01b28def.jpg";